import { Swiper } from 'swiper';
import {Navigation, Autoplay, Pagination} from "swiper/modules";
Swiper.use([Navigation, Autoplay, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-videos-slider="container"]',
        slider: '[js-videos-slider="slider"]',
        prev: '[js-videos-slider="prev"]',
        next: '[js-videos-slider="next"]',
        pagination: '[js-videos-slider="pagination"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)
            let captionEl = container.querySelector('.caption')

            let slider = new Swiper(sliderEl, {
                spaceBetween: 20,
                speed: 500,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    clickable: true,
                    el: container.querySelector(nodeSelectors.pagination),
                },
                breakpoints: {
                    300: {
                        slidesPerView: 1.5,
                        loop: true,
                        centeredSlides: true
                    },
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 2,
                        loop: false,
                        centeredSlides: false
                    },
                    1024: {
                        slidesPerView: 3,
                        loop: false,
                        centeredSlides: false
                    },
                    // when window width is >= 640px
                    1100: {
                        slidesPerView: 5,
                        loop: false,
                        centeredSlides: false
                    }
                },

                on: {
                    init: function () {
                        updateCaption(this)
                    },

                    slideChange: function () {
                        updateCaption(this)
                    }
                }
            });

            function updateCaption(swiper) {
                const activeSlide = swiper.slides[swiper.activeIndex]
                const videoHolder = activeSlide.querySelector('.video-holder')
    
                if (videoHolder && captionEl) {
                    captionEl.innerHTML = videoHolder.dataset.caption || ''
                }
            }
        })

        $('.video-holder').on('click', function(){
            let currentVideo = $(this).data('video');
            $(this).find('.play-icon, .cover-image').fadeOut();
            $(this).find('iframe').attr('src', 'https://www.youtube.com/embed/'+ currentVideo +'?controls=0&amp;autoplay=1');
        })

    }

    return Object.freeze({
        init,
    })
}